<script lang="ts">
    import {
        MyNotificationsCountQueryDocument,
        NavbarQueryDocument,
    } from '$gql/graphql.js';
    import Navbar from '$components/Navbar/Navbar.svelte';
    import { query } from '$lib/apollo/SvelteApollo';

    export let cmsCountryUrl: string;
    export let navbarCountryLink: { withCountry: string; withoutCountry: string } | null =
        null;

    const { result } = query(NavbarQueryDocument, {});
    const { result: myNotificationsCountResult } = query(
        MyNotificationsCountQueryDocument,
        {},
    );

    $: navbar =
        $result.data != null
            ? $result.data
            : ({
                  __typename: 'Query',
                  me: null,
                  urls: {
                      __typename: 'Urls',
                      cmsCountry: cmsCountryUrl,
                  },
                  inboxNbUnreadThreads: 0,
              } as const);

    $: myNotificationsCount = $myNotificationsCountResult.data?.myNotificationsCount ?? 0;
</script>

<Navbar
    {navbar}
    {myNotificationsCount}
    {navbarCountryLink}
    withRightButtons={$result.data != null}
/>
